module.exports = __webpack_public_path__ + "0bc416a3aced71de78a02954a2da51d9.fbx";